import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { BetaTag } from "@/components/BetaTag/BetaTag";

export function PlaygroundSectionCustomSummary() {
  return (
    <Section data-test="custom-summary-section">
      <SectionHeader addon={<BetaTag />}>
        <SectionTitle>Sales discovery summary</SectionTitle>
      </SectionHeader>

      <div className="flex flex-col rounded-md bg-muted p-4">
        <p className="text-sm text-foreground">
          The prospect is evaluating a migration from their legacy phone system
          and is most concerned about call quality and onboarding time.
        </p>
        <p className="mt-2 text-sm text-foreground">
          Next step: schedule a technical deep-dive with their IT lead.
        </p>
      </div>
    </Section>
  );
}
